import { message } from "antd";
import { ExaminationService } from "../../../api/sennotech/scanner/v2/examination";
import { post, url } from "../../../javascripts/http";
import { Language } from "../../../api/sennotech/scanner/v2/type";
import { createAction } from "redux-actions";
import i18n from "../../../i18n";

let language = Language.ZH;
if(i18n.language == "en") {
    language = Language.EN;
}

let examinationService = new ExaminationService(url, post);
export function createExportTask(data: any) {
  return async (dispatch: any) => {
    try {
      const screenee = await examinationService.createExportTask({
        ...data,
        language: language
      });
      return screenee;
    } catch (error) {
      console.log("error", error);
      return "";
    }
  };
}

export function getExportTask(data: any) {
  return async (dispatch: any) => {
    try {
      const exportTask = await examinationService.getExportTask(data);
      dispatch(handleActionGetExportTaskList({ 
        ExportTaskList: exportTask.exportTasks 
      }));
      return exportTask.exportTasks
    } catch (error) {
      console.log("error", error);
    }
  };
}

export const ACTION_GETEXPORTTASKLIST_SUCCESS = 'SILIZHU.ACTION_GETEXPORTTASKLIST_SUCCESS';

export interface ActionGetExportTaskListSuccessPayload {
  ExportTaskList: any;
}

export const handleActionGetExportTaskList = createAction(
  ACTION_GETEXPORTTASKLIST_SUCCESS,
  (payload: ActionGetExportTaskListSuccessPayload) => {
    return payload;
  }
)

export function retryExportTask(data: any) {
  return async (dispatch: any) => {
    try {
      const exportTask = await examinationService.retryExportTask(data);
      return exportTask
    } catch (error) {
      console.log("error", error);
      return "";
    }
  };
}

export function deleteExportTask(data: any) {
  return async (dispatch: any) => {
    try {
      const exportTask = await examinationService.deleteExportTask(data);
      return exportTask
    } catch (error) {
      console.log("error", error);
      return "";
    }
  };
}